// eslint-disable-next-line import/no-unresolved
import { UseInfiniteScrollHookArgs } from 'react-infinite-scroll-hook/dist/useInfiniteScroll'
import useInfiniteScroll from 'react-infinite-scroll-hook'

export const useCustomInfiniteScroll = (data: UseInfiniteScrollHookArgs) => {
  const [sentryRef, { rootRef }] = useInfiniteScroll(data)

  return { containerBottomRef: sentryRef, containerRef: rootRef }
}
